const en = {
  useTemplateOptional: 'Use Template (Optional)',
  createFromScratch: '-- Create from scratch --',
  templateOptionLabel: '{{name}} ({{count}} parts)',
  partsWillBeLoaded: '✓ Parts will be loaded from template automatically',
};

const de = {
  useTemplateOptional: 'Vorlage verwenden (optional)',
  createFromScratch: '-- Von Grund auf neu erstellen --',
  templateOptionLabel: '{{name}} ({{count}} Teile)',
  partsWillBeLoaded: '✓ Teile werden automatisch aus der Vorlage geladen',
};

const templateSelector = { en, de };
export default templateSelector;
